export const alertActions = {
    setMessage: "SET_MESSAGE",
    setError: "SET_ERROR",
}